<pgh-modal-window>
  <div modal-close class="modal-top">
    <button
      mat-icon-button
      class="close-button mat-icon-button"
      (click)="onCancelClicked()"
      sf-aria-label="Global_Close_Window"
      matDialogClose>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div modal-title>
    <div class="mb-10">
      <pgh-avatar name="{{ member.firstName + ' ' + member.lastName }}" color="{{ member.profileColor }}" size="75"></pgh-avatar>
      <!--<img class="current-avatar" [src]="member.avatarUrl || './assets/images/avatars/desktop.png'"
        alt="User Selected Avatar">-->
    </div>
    <h4 *ngIf="isPrimaryUserLoggedIn || isProfileTab; else isHouseholdUser">
      <adp-label labelKey="Account_Manage_Members_P_EditColor"></adp-label>
    </h4>
    <ng-template #isHouseholdUser>
      <adp-label labelKey="Account_Manage_Members_S_EditColor"></adp-label>
    </ng-template>
  </div>
  <div modal-body class="mt-20 mb-20">
    <!--<div class="text-center pb-2" *ngIf="isPrimaryUserLoggedIn || isProfileTab; else isHouseholdUserAvatar">
      <adp-label labelKey="Account_Manage_Members_P_ChooseAvatar"></adp-label>
    </div>-->
    <ng-template #isHouseholdUserAvatar>
      <div class="text-center pb-2">
        <adp-label labelKey="Account_Manage_Members_S_ChooseColor"></adp-label> {{ member.firstName }} {{ member.lastName }}
      </div>
    </ng-template>
    <div class="avatar-list-container" style="max-width: 425px; margin-bottom: 40px">
      <ng-container *ngFor="let selColor of colors; let i = index">
        <ng-container *ngIf="selColor && selColor.length">
          <div style="padding: 6px">
            <button
              style="max-height: 70px; border-radius: 100%; padding: 0px; border: 4px solid transparent; background-color: white"
              [ngClass]="{ selectedColor: selColor === member.profileColor }"
              sf-aria-label="Global_Choose_Avatar_Color_Aria_Label"
              (click)="selectAvatarColor(selColor)"
              gtmClick="Profile color"
              [gtmLinkURL]="selColor">
              <pgh-avatar name="" [color]="selColor" size="60"></pgh-avatar>
            </button>
          </div>
        </ng-container>
      </ng-container>
      <!--<ng-container *ngFor="let avatar of avatarList?.avatars; let i = index">
        <ng-container *ngIf="avatar.image && avatar.image.length">
          <img class="avatar-list-item" [alt]="avatar.image[0]?.alternativeText"
            (click)="selectAvatar(avatar?.image[0])"
            [class.selected]="trimUrl(avatar?.image[0]?.url) === trimUrl(member.avatarUrl)"
            [src]="avatar?.image[0]?.url" />
        </ng-container>
      </ng-container>-->
    </div>
  </div>
  <div modal-footer class="modal-bottom">
    <div class="row reverse-wrap">
      <div class="col-md-6">
        <button
          mat-stroked-button
          color="primary"
          class="border-0"
          (click)="onCancelClicked()"
          [gtmClick]="getViewLabel('Global_Button_Cancel')">
          <adp-label labelKey="Global_Button_Cancel"></adp-label>
        </button>
      </div>
      <div class="col-md-6">
        <button
          mat-flat-button
          color="accent"
          (click)="onSaveClicked()"
          [disabled]="member.profileColor === currentAvatarColor || isSaving"
          [gtmClick]="getViewLabel('Global_Button_Save')">
          <adp-label labelKey="Global_Button_Save"></adp-label>
        </button>
      </div>
    </div>
  </div>
</pgh-modal-window>
